import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent {
    @Input() cssClass: string;
    @Input() label: string;
    @Input() labelPosition: 'before' | 'after';
    @Input() ariaLabel: string;
    @Input() checked: boolean;
    @Input() disabled: boolean;
    @Input() disableRipple: boolean;
    @Output() changeEvent = new EventEmitter<void>();

    changeCheckedState(): void {
        this.changeEvent.emit();
    }
}
